import firebase from 'firebase/app'
import 'firebase/firestore'

var config = {
  apiKey: "AIzaSyBIj7MTX-cLk9JM1IFpmpzmnT99Suh3ovI",
  authDomain: "battleshipgame-qtewty.firebaseapp.com",
  databaseURL: "https://battleshipgame-qtewty.firebaseio.com",
  projectId: "battleshipgame-qtewty",
  storageBucket: "battleshipgame-qtewty.appspot.com",
  messagingSenderId: "537627064769",
  appId: "1:537627064769:web:5b63ccf4c8e765bdd19740"
}

// Get a Firestore instance
export const db = firebase
  .initializeApp(config)
  .firestore()
